//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Fisher_info',
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Neuro/Chart_Fisher_info.vue